// extracted by mini-css-extract-plugin
export default {"spotify":"Spotify_spotify__FMWje"};